import {
  GET_CONGREGATIONS_REDUCER,
  REQUESTED_CONGREGATIONS_REDUCER,
  UPDATE_CONGREGATIONS_PAGINATION,
} from "store/actionTypes";
import { ActionType, CongregationState } from "utils/modals";

const CongregationReducer = (
  state: CongregationState = new CongregationState(),
  action: ActionType
) => {
  switch (action.type) {
    case GET_CONGREGATIONS_REDUCER:
      return {
        ...state,
        congregations: { ...state.congregations, ...action.payload },
      };
    case UPDATE_CONGREGATIONS_PAGINATION:
      return {
        ...state,
        congregations: {
          ...state.congregations,
          page: { ...state.congregations.page, ...action.payload },
        },
      };
    case REQUESTED_CONGREGATIONS_REDUCER:
      return {
        ...state,
        requestCongregation: {
          ...state.requestCongregation,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default CongregationReducer;
